import store from '@/core/store';
import { RouteRecordRaw } from 'vue-router';

const CommunicationOverview = () => import('@/modules/communication/pages/CommunicationOverview.vue');

const COMMUNICATION_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'CommunicationOverview',
      component: CommunicationOverview,
      beforeEnter: (to, from, next) => {
         const { query } = to;

         if (
            (!query.sort && !store.state.communication?.messages?.filterData?.team_id) ||
            (!query.sort?.includes('created_at') && !store.state.communication?.messages?.filterData?.team_id)
         ) {
            return next({
               ...to,
               query: {
                  ...query,
                  sort: '-created_at',
                  page: '1',
                  per_page: '25',
                  'filter[team_id]': store.state.userInfo?.userInfo?.default_team_id,
               },
            });
         }
         if (
            (!query.sort && store.state.communication?.messages?.filterData?.team_id) ||
            (!query.sort?.includes('created_at') && store.state.communication?.messages?.filterData?.team_id)
         ) {
            return next({
               ...to,
               query: {
                  ...query,
                  sort: '-created_at',
                  page: '1',
                  per_page: '25',
                  'filter[team_id]': `${store.state.communication?.messages?.filterData?.team_id}`,
               },
            });
         }

         return next();
      },
   },
];

export { COMMUNICATION_ROUTES };
